import { useEffect, useState } from "react";

import _ from "underscore";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

const GeneralTerms = (props) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [version, setVersion] = useState("");

  useEffect(() => {
    props.getLoanstepGeneralTerms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.terms.generalTermsLS.fetched) {
      let latestTerms = _.sortBy(
        props.terms.generalTermsLS.data,
        (terms) => terms.Version,
      ).at(-1);
      setVersion(latestTerms.Version);
      buildContentState(props.terms.generalTermsLS);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.terms.generalTermsLS.fetching]);

  return (
    <div
      style={{
        padding: "6px 5px 0",
        borderRadius: "2px",
        border: "1px solid #F1F1F1",
        background: "white",
      }}
    >
      {" "}
      <input type="text" value={version} onChange={changeVersion} />
      <input
        type="button"
        value="Send terms"
        onClick={sendNewVersion.bind(this, false)}
      />
      <input
        style={{ float: "right" }}
        type="button"
        value="Send terms without versioning"
        onClick={sendNewVersion.bind(this, true)}
      />
      <Editor
        editorState={editorState}
        onEditorStateChange={onEditorStateChange}
      />
    </div>
  );

  function buildContentState(props) {
    const sortedTerms = _.sortBy(props.data, (terms) => terms.Version);
    const blocksFromHtml = htmlToDraft(sortedTerms.at(-1).Content);
    const contentBlocks = blocksFromHtml.contentBlocks;
    const contentState = ContentState.createFromBlockArray(contentBlocks);
    const _editorState = EditorState.createWithContent(contentState);
    setEditorState(_editorState);
    setVersion(sortedTerms.at(-1).Version);
  }

  function sendNewVersion(ignoreVersioning) {
    const content = editorState.getCurrentContent();
    const rawContent = convertToRaw(content);

    const raw = draftToHtml(rawContent);
    if (ignoreVersioning) props.sendNewLsGeneralTerms(raw, version, true);
    else props.sendNewLsGeneralTerms(raw, version);
  }

  function changeVersion(event) {
    setVersion(event.target.value);
  }

  function onEditorStateChange(editorState) {
    setEditorState(editorState);
  }
};

export default GeneralTerms;
